import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { DailyReportDTO, ErrorDetails, PaymentReportDTO, SurrendersSummarizeDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetSurrenderDailyReportCommand extends IRequestCommand<
  IGetSurrenderDailyReportResponse,
  ErrorDetails,
  IGetSurrenderDailyReportParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/travels/surrendersSummarizedTotals?dateFrom={dateFrom}&dateTo={dateTo}';

  public override setParameters(parameters: IGetSurrenderDailyReportParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{dateFrom}',
      parameters.dateFrom
    );
    this._commandUrl = this._commandUrl.replace(
      '{dateTo}',
      parameters.dateTo
    );
  }
}

export interface IGetSurrenderDailyReportParameters {
  carrierId: number;
  dateFrom: string; // yyyy-MM-dd
  dateTo: string;   // yyyy-MM-dd
}

export interface IGetSurrenderDailyReportResponse extends ICommandResponse {
  aggregatedTotals: SurrendersSummarizeDTO[];
  paymentsTotals: PaymentReportDTO;
  statistics: DailyReportDTO;
}
